
/// <reference path="../../meevoStore.module.ts" />
module Meevo.Plugins.MeevoStore {

    class ModalProcessController {

        static $inject = [
            "$filter",
            "$mdDialog",
            "$translate",
            'meevo.plugins.meevoStore.MeevoStoreService',
            'headerContentKey',
            'confirmText',
            'confirmItem',
        ];
        public isAgreeTerms: boolean = false;
        public documentTerms: IMeevoStoreDocumentPolicy;
        public documentPolicy: IMeevoStoreDocumentPolicy;
        public documentAdjustment: IMeevoStoreDocumentPolicy;

        constructor(
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            protected storeService: Meevo.Plugins.MeevoStore.IMeevoStoreService,
            protected headerContentKey: string,
            protected confirmText: any,
            protected confirmItem: any) {

            this.storeService.getTerms(SystemDocumentsTypeEnum.MeevoStoreTermsAndConditions).then((data) => {
                this.documentTerms = data;
            });
            this.storeService.getTerms(SystemDocumentsTypeEnum.MeevoStorePrivacyPolicy).then((data) => {
                this.documentPolicy = data;
            });
            this.storeService.getTerms(SystemDocumentsTypeEnum.MeevoStoreAdjustment).then((data) => {
                this.documentAdjustment = data;
            });
        }

        apply = () => {
            this.$mdDialog.hide({ status: true });
        };

        cancel = () => {
            this.$mdDialog.hide({ status: false });
        };

        public openTerms (documentsText: string, modalTitle: string = 'LABEL_TERMS_OF_SERVICE') {
            this.storeService.openTermsModal(documentsText, modalTitle);
        }
    }

    angular.module("meevo.plugins.meevoStore")
        .controller("meevo.plugins.meevoStore.ModalProcessController", ModalProcessController);
}
